/**
 * Brazilian Portuguese (pt-BR) mappings for Market Analytics
 */

export const marketAnalyticsPtBR = {
  // Page Title & Status
  "PickStar Exchange": "Câmbio PickStar",
  "PickStar Exchange [Beta]": "Câmbio PickStar [Beta]",
  "LIVE MARKET": "MERCADO AO VIVO",

  // Loading & Error
  "Loading market data...": "Carregando dados do mercado...",
  "Error loading market data:": "Erro ao carregar dados do mercado:",

  // Navigation Pills
  "NFL": "NFL",
  "NCAAF": "NCAAF",
  "MLB": "MLB",
  "MMA": "MMA",
  "FOOTBALL": "FUTEBOL",
  "VOLLEYBALL": "VÔLEI",
  "SPORTS HUB": "CENTRAL DE ESPORTES",

  // CTA Section
  "WANT FRESH PREDICTIONS?": "QUER PREVISÕES RECENTES?",
  "QUICKPICK BOARDS": "PAINÉIS DE PALPITES RÁPIDOS",

  // Controls
  "Sport:": "Esporte:",
  "All Sports": "Todos os Esportes",
  "Football (Soccer)": "Futebol",
  "NBA": "NBA",
  "NHL": "NHL",
  "NCAAB": "NCAAB",

  // Time Range Buttons
  "1H": "1H",
  "24H": "24H",
  "3D": "3D",
  "7D": "7D",

  // Section Headers
  "TRENDING TEAMS": "TIMES EM ALTA",
  "HOT GAMES": "JOGOS QUENTES",

  // Common Terms
  "Confidence": "Confiança",
  "Volume": "Volume",
  "Trend": "Tendência",
  "Market": "Mercado",
  "Activity": "Atividade",
  "Analysis": "Análise",
  "Predictions": "Previsões",

  // Status Indicators
  "Live": "Ao Vivo",
  "Active": "Ativo",
  "Inactive": "Inativo",
  "Rising": "Subindo",
  "Falling": "Caindo",
  "Stable": "Estável",

  // Time Labels
  "Today": "Hoje",
  "Yesterday": "Ontem",
  "This Week": "Esta Semana",
  "Last Week": "Semana Passada",

  // Market Terms
  "Buy": "Comprar",
  "Sell": "Vender",
  "Hold": "Manter",
  "High": "Alta",
  "Low": "Baixa",
  "Average": "Média",
  "Peak": "Pico",

  // Action Buttons
  "View More": "Ver Mais",
  "Refresh": "Atualizar",
  "Filter": "Filtrar",
  "Sort": "Ordenar",
  "Export": "Exportar",

  // Chart Labels
  "Time": "Tempo",
  "Value": "Valor",
  "Change": "Mudança",
  "Percentage": "Porcentagem",

  // Empty States
  "No data available": "Nenhum dado disponível",
  "No games found": "Nenhum jogo encontrado",
  "No teams trending": "Nenhum time em alta",

  // Additional UI Elements
  "Select sport": "Selecionar esporte",
  "Select time range": "Selecionar período",
  "Market overview": "Visão geral do mercado",
  "Team performance": "Desempenho do time",
  "Game insights": "Insights do jogo"
};